export default {
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    blacklist: 'บัญชีดำ',
    createBlacklist: 'เพิ่มบัญชีดำ',
    editBlacklist: 'แก้ไขบัญชีดำ',
    profile: 'ข้อมูล',
    name: 'ชื่อ',
    surname: 'สกุล',
    reason: 'เหตุผลการติดบัญชีดำ (ถ้ามี)',
    status: 'สถานะ',
    placeholderReason: 'เขียนเหตุผล',
    information: 'ข้อมูล',
    requireField: 'กรุณากรอกข้อมูล',
    imageSuggestionText: 'ขนาดของรูปต้องเป็น 25KB ถึง 200KB',
    createdBlacklist: 'สร้าง บัญชีดำ สำเร็จ',
    editedBlacklist: 'แก้ไข บัญชีดำ สำเร็จ',
    somethingWrong: 'เกิดข้อผิดพลาด',
    imageCannotBeEmpty: 'กรุณาเลือกรูปสำหรับบัญชีดำ',
    congratulation: 'ยินดีด้วย',
    reasonShown: 'เหตุผลการติดบัญชีดำ'
}
